<div *ngIf="spinnerIsShown"
    style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
    <div class="spinner-border text-primary avatar-sm" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
<div class="modal-content border-0">
    <div class="invisible-scrollbar" style=" overflow: scroll; min-height: 50vh; max-height:fit-content; ">
        <div class="modal-body" style="padding-bottom: 0px;">

            <div class="row g-3">

                <div class="position-absolute icon">
                    <div class="d-inline-block">
                        <div class="avatar-lg p-1">
                            <div class="avatar-title bg-light rounded-circle">
                                <img src="{{getDocumentImageUrl(myfile)}}" id="companylogo-img"
                                    class="avatar-md rounded-circle" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-12">
                    <div class="px-1 pt-1">
                        <div class="modal-team-cover position-relative mb-0 mt-n4 mx-n4 rounded-top overflow-hidden">

                            <strong>
                                <img src="{{getDocumentImageUrl(myfile)}}" alt="" id="modal-cover-img">

                                <div class="d-flex position-absolute start-0 end-0 top-0 p-3">

                                    <div class="flex-grow-1"
                                        style="color: rgb(255, 255, 255); text-align: center; text-shadow: 2px 2px 10px black;">
                                        <div style="font-size: 28px;">
                                            {{documentTemplate.name}}
                                        </div>

                                    </div>
                                    <div class="flex-shrink-0 ">

                                        <div class="d-flex gap-3 align-items-center">

                                            <button type="button" class="btn-close"
                                                style="background-color: rgba(0, 0, 0, 0.1)" (click)="close()"
                                                id="close-jobListModal" data-bs-dismiss="modal" aria-label="Close">
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </strong>
                        </div>
                    </div>
                    <div>
                        <ul ngbNav #customNav="ngbNav" [(activeId)]="activeTab"
                            style="margin-right:-1.25rem; margin-left:-1.25rem; margin-top: 0rem;"
                            class="nav nav-tabs-custom  card-header-tabs border-bottom-0center justify-content-center mb-2"
                            role="tablist">
                            <li [ngbNavItem]="1" class="nav-item">
                                <ng-template ngbNavContent>
                                    <span *ngIf="documentTemplate.text else elseNoText">
                                        <app-rich-text-displayer *ngIf="documentTemplate.text"
                                            [textToDisplay]="documentTemplate.text"></app-rich-text-displayer>
                                    </span>
                                    <ng-template #elseNoText>
                                        <app-rich-text-displayer
                                            [textToDisplay]="documentTemplate.description"></app-rich-text-displayer>
                                    </ng-template>
                                </ng-template>
                            </li>


                        </ul>
                    </div>

                    <div class="tab-model d-flex row justify-content-between" style="margin-right: 0.1rem;">
                        <div [ngClass]="{'col-6': serviceFee != undefined, 'col-12': serviceFee == undefined}" [ngbNavOutlet]="customNav"></div>
                        <div *ngIf="serviceFee" class="card col-6">
                            <div class="card-body bg-light m-2 ">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="flex-grow-1">
                                        <h5 class="mb-0">Service Fee</h5>
                                    </div>
                                    <div class="ms-auto">
                                        <h2 class="month mb-0">{{serviceFee.value |currency}}</h2>
                                    </div>
                                </div>
                                <p class="text-muted">You will be charged an additional fee of: {{serviceFee.value
                                    |currency}} to cover credit card processing fees for this deposit. </p>
                            </div>
                            <div class="card-body bg-light m-2 ">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="flex-grow-1">
                                        <h5 class="mb-0">Total</h5>
                                    </div>
                                    <div class="ms-auto">
                                        <h2 class="month mb-0">{{totalAmountCharged |currency}}</h2>
                                    </div>
                                </div>
                                <p class="text-muted">Your card will reflect the a final total statement of {{totalAmountCharged|currency}}. A total of 100 dollars will be deposited into your account, and all future requests will use these funds for processing them. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="padding: 1.25rem; padding-top: 0;">
        <div *ngIf="!requisition.id && securityPermissionRequisitionCreate"
            style="display: flex; justify-content: end;">

            <!-- <button class="btn btn-primary" [disabled]="spinnerIsShown">
                <span i18n="@@">Coming Soon</span>
            </button> -->

            <button class="btn btn-primary" (click)="save()" [disabled]="spinnerIsShown">
                <span i18n="@@">Checkout</span>
            </button>

        </div>

    </div>
</div>